import { FormErrors } from 'redux-form';
import { clearEmptyFields } from 'logic/validators/utils';
import { isRequiredValidator } from 'logic/validators/validators';
import { isValidPhoneNumber } from 'logic/phone/phone.validator';

export const UPDATE_PHONE_NUMBER_FORM_NAME = 'update-phone-number';

export enum UpdatePhoneNumberField {
  phoneCountryCode = 'phoneCountryCode',
  phoneNumber = 'phoneNumber',
}

export interface UpdatePhoneNumberFormValues {
  [UpdatePhoneNumberField.phoneCountryCode]?: string;
  [UpdatePhoneNumberField.phoneNumber]?: string;
}

export type UpdatePhoneNumberFormValidationErrors = FormErrors<UpdatePhoneNumberFormValues, any>;

export const validateUpdatedPhoneNumberForm = (formValues: UpdatePhoneNumberFormValues) => {
  const { phoneCountryCode, phoneNumber } = formValues;

  const errors: UpdatePhoneNumberFormValidationErrors = {
    phoneNumber:
      isRequiredValidator(phoneNumber) || isValidPhoneNumber(phoneNumber, phoneCountryCode),
  };

  return clearEmptyFields(errors);
};
